import { useEffect, useMemo, useState } from "react";
import axios from "../../../api/axios";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";

export default function Arrears() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    pfno: "",
    yr: "",
    mth: "",
  });

  const [form, setForm] = useState({
    pfno: "",
    pay_item: "",
    description: "",
    mth: "",
    yr: "",
    amount: "",
    remarks: "",
  });

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/arrears", {
        params: {
          pfno: filters.pfno || undefined,
          yr: filters.yr || undefined,
          mth: filters.mth || undefined,
          per_page: 200,
        },
      });
      setRows(res.data?.data || []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const create = async () => {
    await axios.post("/arrears", {
      ...form,
      mth: Number(form.mth),
      yr: Number(form.yr),
      amount: Number(form.amount || 0),
    });
    setForm({
      pfno: "",
      pay_item: "",
      description: "",
      mth: "",
      yr: "",
      amount: "",
      remarks: "",
    });
    await load();
  };

  const columns = useMemo(
    () => [
      { Header: "PFNO", accessor: "pf_no" },
      { Header: "Name", accessor: "name" },
      { Header: "Pay Item", accessor: "pay_item" },
      { Header: "Description", accessor: "description" },
      { Header: "Month", accessor: "mth" },
      { Header: "Year", accessor: "yr" },
      { Header: "Amount", accessor: "amount" },
      { Header: "Remarks", accessor: "remarks" },
    ],
    []
  );

  return (
    <MDBox p={3}>
      <MDBox
        mb={3}
        p={3}
        borderRadius="xl"
        sx={{
          background: "linear-gradient(135deg, #006064 0%, #00838f 50%, #26c6da 100%)",
          color: "#fff",
          boxShadow: "0 12px 30px rgba(0,96,100,0.20)",
        }}
      >
        <MDTypography variant="h4" color="white">
          Arrears
        </MDTypography>
        <MDTypography variant="button" color="white">
          Manage one-off arrears and month/year specific payroll corrections.
        </MDTypography>
      </MDBox>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h6">Create Arrear</MDTypography>

              <MDBox mt={2} display="flex" flexDirection="column" gap={2}>
                <MDInput
                  label="PF No"
                  value={form.pfno}
                  onChange={(e) => setForm({ ...form, pfno: e.target.value })}
                />
                <MDInput
                  label="Pay Item"
                  value={form.pay_item}
                  onChange={(e) => setForm({ ...form, pay_item: e.target.value })}
                />
                <MDInput
                  label="Description"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                />
                <MDInput
                  label="Month"
                  type="number"
                  value={form.mth}
                  onChange={(e) => setForm({ ...form, mth: e.target.value })}
                />
                <MDInput
                  label="Year"
                  type="number"
                  value={form.yr}
                  onChange={(e) => setForm({ ...form, yr: e.target.value })}
                />
                <MDInput
                  label="Amount"
                  type="number"
                  value={form.amount}
                  onChange={(e) => setForm({ ...form, amount: e.target.value })}
                />
                <MDInput
                  label="Remarks"
                  value={form.remarks}
                  onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                />

                <MDButton color="info" onClick={create} disabled={loading}>
                  Save Arrear
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </Grid>

        <Grid item xs={12} lg={8}>
          <Card>
            <MDBox p={3}>
              <MDTypography variant="h6">Arrears Register</MDTypography>

              <MDBox mt={2} display="flex" gap={2} flexWrap="wrap">
                <MDBox width={160}>
                  <MDInput
                    label="Filter PF No"
                    value={filters.pfno}
                    onChange={(e) => setFilters({ ...filters, pfno: e.target.value })}
                  />
                </MDBox>
                <MDBox width={120}>
                  <MDInput
                    label="Year"
                    value={filters.yr}
                    onChange={(e) => setFilters({ ...filters, yr: e.target.value })}
                  />
                </MDBox>
                <MDBox width={120}>
                  <MDInput
                    label="Month"
                    value={filters.mth}
                    onChange={(e) => setFilters({ ...filters, mth: e.target.value })}
                  />
                </MDBox>
                <MDButton color="secondary" onClick={load} disabled={loading}>
                  Load
                </MDButton>
              </MDBox>

              <MDBox mt={2}>
                <DataTable
                  table={{ columns, rows }}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  canSearch
                  pagination
                  noEndBorder
                />
              </MDBox>
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}
